@if (absence(); as absenceRecord) {
  @if (absenceRecord.AbsenteeDay && absenceRecord.AbsenteeDay[date()]; as absenteeDay) {
    <div
      class="timesheet__item timesheet__status timesheet-column--status"
      [ngClass]="{
        'timesheet__status--approved': absenceRecord.status === 'Approved',
        'timesheet__status--declined': absenceRecord.status === 'Declined',
        'timesheet__status--pending': absenceRecord.status === 'Pending',
      }"
    ></div>
    <div class="timesheet__item timesheet-column--start">
      @if (absenteeDay.partial_day) {
        <span>{{ absenteeDay.startTime | time }}</span>
      }
    </div>
    <div class="timesheet__item timesheet-column--end">
      @if (absenteeDay.partial_day) {
        <span>{{ absenteeDay.endTime | time }}</span>
      }
    </div>
    <!--
      An absence has nothing to show in the columns below, but the cells still have
      to be here: the details column that follows lines up with the header's only
      while every row in front of it declares the same columns.
    -->
    @if (cols()?.break) {
      <div class="timesheet__item timesheet-column--break"></div>
    }
    @if (cols()?.paidBreak) {
      <div class="timesheet__item timesheet-column--paid-break"></div>
    }
    @if (cols()?.location) {
      <div class="timesheet__item timesheet-column--location"></div>
    }
    @if (cols()?.department) {
      <div class="timesheet__item timesheet-column--department"></div>
    }
    @if (cols()?.team) {
      <div class="timesheet__item timesheet-column--team"></div>
    }
    @if (cols()?.shift) {
      <div class="timesheet__item timesheet-column--shift"></div>
    }
    @if (cols()?.surcharge) {
      <div class="timesheet__item timesheet-column--surcharge"></div>
    }
    @if (cols()?.km) {
      <div class="timesheet__item timesheet-column--km"></div>
    }
    @if (cols()?.meals) {
      <div class="timesheet__item timesheet-column--meals"></div>
    }
    @if (cols()?.note) {
      <div class="timesheet__item timesheet-column--note"></div>
    }
    @for (customField of customFields(); track customField.id) {
      @if (customFieldCols()?.[customField.id]) {
        <div class="timesheet__item" [style.width.px]="customField.width"></div>
      }
    }
    <div class="timesheet__item timesheet__details timesheet-column--details">
      <span class="timesheet__schedule-label">{{ 'Absent' | translate }}</span>
      <span class="timesheet__schedule-label">{{ absenceRecord.absenteeOption?.option }}</span>
      @if (!absenteeDay.partial_day) {
        <span class="timesheet__schedule-label">
          {{ 'Full day' | translate }}
        </span>
      } @else {
        @if (absenceRecord.absenteeOption?.unit === absenceOptionUnit.DAYS) {
          <span class="timesheet__schedule-label">
            {{ 'Half day' | translate }}
          </span>
        } @else {
          <span class="timesheet__schedule-label">
            {{ absenteeDay.start_time | time }} - {{ absenteeDay.endTime | time }}
          </span>
        }
      }
    </div>
  }
}
